import React from 'react';

const ConsentDetailsForm = ({ formData, setFormData, typeInfo, loading, onBack, onSubmit }) => (
  <div className="space-y-4">
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-semibold text-gray-900">Consent Details</h3>
      <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded">
        {typeInfo?.name}
      </span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Procedure/Treatment Name *</label>
        <input
          type="text"
          value={formData.procedure_name}
          onChange={(e) => setFormData({...formData, procedure_name: e.target.value})}
          className="w-full p-2 border rounded-lg"
          placeholder="e.g., Appendectomy, Chemotherapy"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Scheduled Date</label>
        <input
          type="date"
          value={formData.procedure_date}
          onChange={(e) => setFormData({...formData, procedure_date: e.target.value})}
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Attending Physician *</label>
        <input
          type="text"
          value={formData.attending_physician}
          onChange={(e) => setFormData({...formData, attending_physician: e.target.value})}
          className="w-full p-2 border rounded-lg"
          placeholder="Dr. Name"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Patient Language</label>
        <select
          value={formData.patient_language}
          onChange={(e) => setFormData({...formData, patient_language: e.target.value})}
          className="w-full p-2 border rounded-lg"
        >
          <option value="English">English</option>
          <option value="Hindi">Hindi</option>
          <option value="Tamil">Tamil</option>
          <option value="Telugu">Telugu</option>
          <option value="Bengali">Bengali</option>
          <option value="Marathi">Marathi</option>
          <option value="Other">Other</option>
        </select>
      </div>

      {typeInfo?.witness_required && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Witness Name *</label>
            <input
              type="text"
              value={formData.witness_name}
              onChange={(e) => setFormData({...formData, witness_name: e.target.value})}
              className="w-full p-2 border rounded-lg"
              placeholder="Full name of witness"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Witness Relationship</label>
            <select
              value={formData.witness_relationship}
              onChange={(e) => setFormData({...formData, witness_relationship: e.target.value})}
              className="w-full p-2 border rounded-lg"
            >
              <option value="">Select...</option>
              <option value="spouse">Spouse</option>
              <option value="parent">Parent</option>
              <option value="child">Child</option>
              <option value="sibling">Sibling</option>
              <option value="relative">Other Relative</option>
              <option value="friend">Friend</option>
              <option value="staff">Hospital Staff</option>
            </select>
          </div>
        </>
      )}
    </div>

    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="interpreter"
          checked={formData.interpreter_used}
          onChange={(e) => setFormData({...formData, interpreter_used: e.target.checked})}
          className="rounded"
        />
        <label htmlFor="interpreter" className="text-sm">Interpreter used</label>
        {formData.interpreter_used && (
          <input
            type="text"
            value={formData.interpreter_language}
            onChange={(e) => setFormData({...formData, interpreter_language: e.target.value})}
            className="ml-2 p-1 border rounded text-sm"
            placeholder="Language"
          />
        )}
      </div>
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="capacity"
          checked={formData.mental_capacity_confirmed}
          onChange={(e) => setFormData({...formData, mental_capacity_confirmed: e.target.checked})}
          className="rounded"
        />
        <label htmlFor="capacity" className="text-sm">Patient has mental capacity to consent</label>
      </div>
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="questions"
          checked={formData.questions_answered}
          onChange={(e) => setFormData({...formData, questions_answered: e.target.checked})}
          className="rounded"
        />
        <label htmlFor="questions" className="text-sm">All patient questions have been answered</label>
      </div>
    </div>

    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">Additional Notes</label>
      <textarea
        value={formData.additional_notes}
        onChange={(e) => setFormData({...formData, additional_notes: e.target.value})}
        className="w-full p-2 border rounded-lg"
        rows={2}
        placeholder="Any additional notes..."
      />
    </div>

    <div className="flex justify-between">
      <button onClick={onBack} className="px-4 py-2 border rounded-lg hover:bg-gray-50">
        Back
      </button>
      <button
        onClick={onSubmit}
        disabled={!formData.procedure_name || !formData.attending_physician || loading}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? 'Creating...' : 'Next: Record Video'}
      </button>
    </div>
  </div>
);

export default ConsentDetailsForm;
